import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { IconButton } from '@design-system/components/button/iconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { ButtonLink } from '@design-system/components/button/button';
import { F0 } from '@client/new/helpers/types';
import { PATHS } from '@client/paths';

export const ExtrasCreatedToast = (p: { creatorId: number; onClose: F0 }) => {
  const { creatorId, onClose } = p;
  const offersUrl = PATHS.BUNDLES(creatorId);

  return (
    <Row alignCenter>
      <Typography variant="body" fontWeight="medium">
        Content is saved. Publish to make it visible to users or add it to an
        offer
      </Typography>

      <ButtonLink variant="text" color="primary" to={offersUrl}>
        Go to offers
      </ButtonLink>

      <IconButton variant="text" color="primary" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </IconButton>
    </Row>
  );
};
